import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  Pagination
} from "@mui/material";
import Breadcrumb from "../components/Breadcrumb";
import Cards from "../components/Cards";
import vendor1 from "../assests/vendor1.png";
import vendor2 from "../assests/vendor2.png";
import vendor3 from "../assests/vendor3.png";
import vendor4 from "../assests/vendor4.png";
import vendor5 from "../assests/vendor5.png";
import vendor6 from "../assests/vendor6.png";
import BecomeVendor from "../components/BecomeVendor";
import { useVendorStore } from "../store/useVendorStore";
import Loader from "../components/Loader/Loader";

const Vendor = () => {
  const vendorDetails = [
    {
      image: vendor1,
      title: "medline",
      description: `There are many variations of passages of Lorem
Ipsum available, but the majority have suffered
alteration in some form`,
    },
    {
      image: vendor2,
      title: "abbott laboratories",
      description: `There are many variations of passages of Lorem
Ipsum available, but the majority have suffered
alteration in some form`,
    },
    {
      image: vendor3,
      title: "siemens healthiners",
      description: `There are many variations of passages of Lorem
Ipsum available, but the majority have suffered
alteration in some form`,
    },
    {
      image: vendor4,
      title: "Johnson & Johnson",
      description: `There are many variations of passages of Lorem
Ipsum available, but the majority have suffered
alteration in some form`,
    },
    {
      image: vendor5,
      title: "General Electric (GE)",
      description: `There are many variations of passages of Lorem
Ipsum available, but the majority have suffered
alteration in some form`,
    },
    {
      image: vendor6,
      title: "Cardinal Health",
      description: `There are many variations of passages of Lorem
Ipsum available, but the majority have suffered
alteration in some form`,
    },
  ];

  const handleChangePagination = (event, value) => {
    setPageNumber(value);
  };

  const [totalPages, setTotalPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [field, setField] = useState('');

  const { getAllVendor, vendor, loading } = useVendorStore()

  const getAllVendorFunctioncaller = async () => {
    const data = await getAllVendor(pageNumber, pageSize, '', '')
    if (data) {
      setTotalPages(data?.totalPages)
    }
  }

  useEffect(() => {
    getAllVendorFunctioncaller()
  }, [pageNumber, field])

  return (
    <>
      <Breadcrumb title="Vendors" />
      <Box sx={{ padding: '60px 0' }}>
        <Loader loading={loading} />
        <Container
          maxWidth="xl">
          <Typography className="titleSec" sx={{
            marginBottom: "50px",
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            '& span': {
              fontFamily: `"Quicksand", sans-serif`,
              fontWeight: 700,
              lineHeight: "24px",
              fontSize: { xs: "16px", md: "22px", lg: "24px" },
              color: "#008BFF",
              textAlign: "center",
            },
          }}><span>Vendor</span>Our Great Vendors</Typography>
          <Grid container spacing={2}>
            {(vendor || []).map((vendorDetail, index) => (
              <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
                <Cards
                  key={index}
                   displayImage={true}
                  title={vendorDetail?.vendorName}
                  description={vendorDetail?.additionalNotes}
                  image={vendorDetail?.vendorLogo}
                  buttonText="visit store"
                  buttonTextUrl={vendorDetail?.website}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent:'center',
        marginBottom:'50px',

      }}>
        <Stack spacing={2} className="flex items-end mt-4 mb-5 mr-4 ">
          <Pagination
            count={totalPages}
            onChange={handleChangePagination}
            variant="outlined"
            shape="rounded"
          />
        </Stack>
      </Box>

      <BecomeVendor />
    </>
  );
};

export default Vendor;
